import { singleline } from "@core/foundation/string";
import type { ZodType } from "@core/zod";
import { z } from "@core/zod";

export interface AstGrepRule {
  readonly all?: readonly AstGrepRule[];
  readonly has?: AstGrepRelation;
  readonly inside?: AstGrepRelation;
  readonly kind?: string;
  readonly not?: AstGrepRule;
  readonly pattern?: string;
  readonly regex?: string;
}

interface AstGrepRelation extends AstGrepRule {
  readonly stopBy?: "end" | "neighbor";
}

export const AstGrepRuleSchema: ZodType<AstGrepRule> = z.object(
  {
    get all() {
      return z.array(AstGrepRuleSchema).optional();
    },
    get has() {
      return AstGrepRelationSchema.optional();
    },
    get inside() {
      return AstGrepRelationSchema.optional();
    },
    kind: z.string().optional(),
    get not() {
      return AstGrepRuleSchema.optional();
    },
    pattern: z.string().optional(),
    regex: z.string().optional(),
  },
  {
    all: "The rules a node must match every one of.",
    has: "The rule a descendant of the node must match.",
    inside: "The rule an ancestor of the node must match.",
    kind: "The tree-sitter kind the node must have.",
    not: "The rule the node must not match.",
    pattern: "The code pattern the node must match.",
    regex: "The regular expression the node's text must match.",
  },
);

const AstGrepRelationSchema: ZodType<AstGrepRelation> = z.intersection(
  AstGrepRuleSchema,
  z.object(
    { stopBy: z.enum(["end", "neighbor"]).optional() },
    {
      stopBy: singleline`
        How far the search for the related node reaches, either to the end of
        the tree or to the neighbor alone.
      `,
    },
  ),
);
